import { BILLS_TAGS, INVOICE_TAGS_INFO } from 'app-constants'
import { isValidPaymentRecurring } from './invoice'

export function getTagInfo(
  paid,
  isPaymentRecurring = false,
  tags = [],
  paymentType = null,
  dueDate = null
) {
  const isNegotiated = tags.includes(BILLS_TAGS.IN_NEGOTIATION)

  if (isNegotiated) return INVOICE_TAGS_INFO.NEGOTIATED

  if (isPaymentRecurring) {
    const isActivePaymentRecurring = isValidPaymentRecurring(
      isPaymentRecurring,
      paymentType,
      dueDate
    )
    return isActivePaymentRecurring ? INVOICE_TAGS_INFO.SCHEDULED : INVOICE_TAGS_INFO.EXPIRED
  }
  return paid ? INVOICE_TAGS_INFO.PAID : INVOICE_TAGS_INFO.OPEN
}
